import { TripSanitarityCostMode } from 'app/constants/configuration/tripSanitarityCostMode'

export const getTripSanitarityCostModeName = (
  tripSanitarityCostMode: TripSanitarityCostMode,
  translate: (string) => string,
): string => {
  const text: string = TripSanitarityCostMode[tripSanitarityCostMode]
  return translate(`tripSanitarityCostMode.${text}`)
}
